import { PanelClass } from '@mairistem/finances-utils';

class MouvementPanel extends PanelClass {
  // Propriété qui sert à savoir si le bloc affecte le mouvement ou les lignes
  isOnlyMouvement = true;
}

export default MouvementPanel;
